export default __webpack_public_path__ + "static/media/ro.060678c5.jpg";